import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Clock, ArrowRight, MessageCircle, Phone, Tag } from 'lucide-react';
import { PACKAGES, DESTINATIONS, COMPANY } from '../../mock';
import { Button } from '../ui/button';

export function PackageCard({ pkg }) {
  const dest = DESTINATIONS.find(d => d.slug === pkg.destination);
  const discount = Math.round(((pkg.oldPrice - pkg.price) / pkg.oldPrice) * 100);
  const isTaxiTour = pkg.tags.includes('Taxi Tour');
  return (
    <div className="group bg-white rounded-2xl overflow-hidden border border-brand-greyDark shadow-card card-hover animate-fade-up">
      <Link to={`/packages/${pkg.slug}`} className="block">
        <div className="relative aspect-[4/3] img-zoom-wrap overflow-hidden">
          <img src={pkg.image} alt={pkg.title} className="absolute inset-0 w-full h-full object-cover img-zoom" />
          <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap">
            {pkg.tags.map(t => (
              <span key={t} className="text-[10.5px] font-semibold uppercase tracking-wider px-2 py-1 bg-white/95 backdrop-blur-sm text-brand-blue rounded-md">{t}</span>
            ))}
          </div>
          {discount > 0 && (
            <div className="absolute top-3 right-3 bg-brand-orange text-white text-[11px] font-bold px-2.5 py-1 rounded-md flex items-center gap-1">
              <Tag size={11} /> {discount}% OFF
            </div>
          )}
        </div>
        <div className="p-5 pb-3">
          <div className="text-[11px] text-brand-blue/55 uppercase tracking-wider font-semibold mb-1.5">{dest?.name || pkg.destination}</div>
          <h3 className="font-poppins font-bold text-brand-blue text-[16.5px] leading-snug group-hover:text-brand-orange transition-colors line-clamp-2">{pkg.title}</h3>
          <div className="flex items-center gap-3 mt-2.5 text-[12px] text-brand-blue/60">
            <span className="flex items-center gap-1"><Clock size={12} /> {pkg.nights}N / {pkg.days}D</span>
            <span className="flex items-center gap-1"><Star size={12} className="fill-brand-orange text-brand-orange" /> {pkg.rating} ({pkg.reviews})</span>
          </div>
          <div className="mt-3 pt-3 border-t border-brand-grey flex items-end justify-between">
            <div>
              <div className="text-[10.5px] text-brand-blue/50 line-through">₹{pkg.oldPrice.toLocaleString('en-IN')}</div>
              <div className="font-poppins font-bold text-brand-blue text-[19px] leading-none">{isTaxiTour ? 'From ' : ''}₹{pkg.price.toLocaleString('en-IN')}<span className="text-[11px] text-brand-blue/55 font-normal">{isTaxiTour ? '' : '/person'}</span></div>
            </div>
            <div className="text-brand-orange font-semibold text-[12.5px] flex items-center gap-1 group-hover:gap-2 transition-all">View Details <ArrowRight size={13}/></div>
          </div>
        </div>
      </Link>
      <div className="px-5 pb-4 pt-0 flex gap-2">
        <a href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent('Hi Mountains Chain Travel! 👋\n\nI\'m interested in the "' + pkg.title + '" package (' + pkg.nights + 'N/' + pkg.days + 'D) for ₹' + pkg.price.toLocaleString('en-IN') + '.\n\nPlease share the detailed itinerary and any available discounts.\n\nThanks!')}`} target="_blank" rel="noreferrer" className="flex-1">
          <Button className="w-full bg-emerald-500 hover:bg-emerald-600 text-white text-[11.5px] font-semibold h-9 rounded-lg flex items-center justify-center gap-1.5"><MessageCircle size={14} />WhatsApp</Button>
        </a>
        <Button onClick={() => window.dispatchEvent(new CustomEvent('mct:openEnquiry'))} className="flex-1 bg-brand-orange hover:bg-brand-orangeDark text-white text-[11.5px] font-semibold h-9 rounded-lg flex items-center justify-center gap-1.5"><Phone size={14} />Get Quote</Button>
      </div>
    </div>
  );
}

export function PackagesPreview() {
  const featured = PACKAGES.filter(p => p.tags.includes('Bestseller')).slice(0, 6);
  return (
    <section className="max-w-7xl mx-auto px-6 py-20 lg:py-24">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
        <div>
          <div className="text-brand-orange text-[13px] font-semibold tracking-[0.18em] uppercase mb-2">Bestseller Packages</div>
          <h2 className="font-poppins text-[34px] lg:text-[44px] text-brand-blue leading-[1.1]">Trips our travelers <span className="text-brand-orange">love the most</span></h2>
        </div>
        <Link to="/packages" className="text-brand-blue font-semibold border-b-2 border-brand-orange pb-1 hover:text-brand-orange transition-colors flex items-center gap-2 self-start md:self-auto">
          See all packages <ArrowRight size={16}/>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {featured.map(p => <PackageCard key={p.id} pkg={p} />)}
      </div>
    </section>
  );
}
